import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    cards: {},
    maxCardsAllowed: 4
  },
  mutations: {
    initializeStore(state) {
      if (localStorage.getItem('cardCompareStore')) {
        this.replaceState(
          Object.assign(
            state,
            JSON.parse(localStorage.getItem('cardCompareStore'))
          )
        )
      }
    },
    addCardToStore(state, payload) {
      Vue.set(state.cards, payload.slug, payload)
    },
    removeCardFromStore(state, payload) {
      Vue.delete(state.cards, payload.slug)
    },
    removeAllCards(state) {
      state.cards = {}
    }
  },
  actions: {
    addCard({ commit }, payload) {
      commit('addCardToStore', payload)
    },
    removeCard({ commit }, payload) {
      commit('removeCardFromStore', payload)
    },
    resetCards({ commit }) {
      commit('removeAllCards')
    }
  },
  getters: {
    cardsForComparison: state => {
      return state.cards
    },
    cardCount: state => {
      return Object.keys(state.cards).length
    },
    isCardSelected: (state, getters) => slug => {
      return getters.cardsForComparison.hasOwnProperty(slug)
    },
    isComparable: state => {
      return Object.keys(state.cards).length > 1
    },
    isMaxSelected: state => {
      return Object.keys(state.cards).length >= state.maxCardsAllowed
    },
    maxCardsAllowed: state => {
      return state.maxCardsAllowed
    },
    compareUrl: state => {
      return '/credit-cards/compare/' + Object.keys(state.cards).join('/') + '/'
    }
  }
})

window.addEventListener('focus', function() {
  store.commit('initializeStore')
})

store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('cardCompareStore', JSON.stringify(state))
})

export default store
